package br.com.vvrefeicoes.portal.domain.repository

import br.com.vvrefeicoes.portal.domain.model.OrgChartVersion

data class OrgChartSnapshot(
    val versions: List<OrgChartVersion>,
    val currentVersion: OrgChartVersion,
    val draft: OrgChartVersion?,
)

interface OrgChartRepository {
    suspend fun loadInitial(): OrgChartSnapshot

    suspend fun createDraft(): OrgChartVersion

    suspend fun saveDraft(draft: OrgChartVersion)

    suspend fun publish(
        draft: OrgChartVersion,
        changes: List<String> = emptyList(),
    ): OrgChartVersion

    suspend fun discardDraft(id: String)

    suspend fun loadSupervisorCandidates(): List<UserCandidate>

    suspend fun loadDirectorCandidates(): List<UserCandidate>

    suspend fun loadManagerCandidates(): List<UserCandidate>

    /** Atualiza os supervisores de uma unidade no organograma vigente, sem gerar nova versão. */
    suspend fun saveUnitSupervisors(
        companyId: String,
        supervisorIds: List<String>,
    )
}
